export default __webpack_public_path__ + "static/media/parallax1.1153c55b.jpg";